<!--
 * @Author: qx
 * @Date: 2022-10-20 13:52:56
 * @LastEditTime: 2022-10-31 14:13:32
 * @LastEditors: qx
 * @Description: 生态合作
-->
<template>
  <div class="cooperation">
    <el-button type="primary" class="fixd-but" v-show="showJoin" size="small" @click="joinHandle">加入我们</el-button>
    <div class="top rf jc">
      <div class="top-left">
        <div class="left-content cf jc ac">
          <div class="title">合作须知</div>
          <div class="title-en">Cooperation Instructions</div>
        </div>
      </div>
      <div class="top-right">
        <div class="right-content cf jc ac">
          <div style="width: 100%; font-size: 28px; color: red">
            仅限经销商授权申请
          </div>
          <div class="title"> 合作伙伴经公司报备审批同意后，在公司授权的集团/公司客户范围内向用户销售公司授权产品的企业或组织。授权合作伙伴与公司达成年度合作协议，在合作期限内以授权合作伙伴自己的名义从公司购买产品，并且以授权合作伙伴自己的名义进行产品转售。</div>
          <div class="right-content-en">
            <el-button type="primary" size="small" @click="joinHandle">加入我们</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 授权产品 -->
    <div class="cf jc ac" style="margin: 16px 0;">
      <div class="title">授权产品</div>
      <div class="title-en">Authorized Products</div>
    </div>
    <div class="rf jsa">
      <div class="product">
        <div class="product-up pu1">控制系统及相关产品</div>
        <div class="product-down pd1">
          <div>集散控制系统</div>
          <div>安全仪表系统</div>
          <div>PCL(可编程逻辑控制器)</div>
          <div>行业专用系统</div>
          <div>工业信息安全</div>
        </div>
      </div>
      <div class="product">
        <div class="product-up pu2">仪器仪表相关产品</div>
        <div class="product-down pd2">
          <div>智能压力变送器</div>
          <div>工具类仪表</div>
          <div>信号类仪表</div>
          <div>液位仪表</div>
          <div>流量仪表</div>
          <div>气体探测仪</div>
          <div>显示控制仪表</div>
          <div>ZKJ系列智能端盖</div>
        </div>
      </div>
      <div class="product">
        <div class="product-up pu3">控制阀、控制柜及电气服务</div>
        <div class="product-down pd3">
          <div>调节阀</div>
          <div>切断阀</div>
          <div>机柜及机箱系列</div>
          <div>配电柜</div>
        </div>
      </div>
      <div class="product">
        <div class="product-up pu4">工业软件</div>
        <div class="product-down pd4">
          <div>安全管理</div>
          <div>生产管控</div>
          <div>能源管理</div>
          <div>供应链管理</div>
          <div>资产管理</div>
          <div>数字孪生</div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="cf jc ac top-40">
      <div class="title">合作伙伴</div>
      <div class="title-en">Cooperative partner</div>
    </div>
    <el-row :gutter="20" style="margin: 0 100px">
      <el-col :span="6" v-for="item in dataList" :key="item.companyId">
        <div class="company rfw jc ac">{{item.companyName}}</div>
      </el-col>
    </el-row>
    <el-pagination background
      style="margin-top:10px;text-align: center;"
      layout="prev, pager, next, total, jumper, slot"
      prev-text="上一页"
      next-text="下一页"
      @current-change="getList"
      :current-page="currentPage"
      :page-size="20"
      :pager-count="5"
      :total="total"
      v-if="total>20">
    </el-pagination>

    <!-- 登录提示 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="() => handleClose(1)">
      <span>您尚未登录，请先登录操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose(1)">暂不登录</el-button>
        <el-button type="primary" @click="handleClose(2)">去登录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      dataList: [],
      dialogVisible: false,
      showJoin: false,
      // 分页
      currentPage: 1,
      total: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.showAddBut)
    this.getList(1)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.showAddBut)
  },
  methods: {
    joinHandle () {
      if (getAccessToken() === '' || getAccessToken() === undefined) {
        this.dialogVisible = true
      } else {
        this.$router.push({
          name: 'ecologicalCooperationRequirements'
        })
      }
    },
    handleClose (val = 1) {
      this.dialogVisible = false
      if (val === 2) {
        this.$router.push({
          name: 'login'
        })
      }
    },
    // 判断当前加入按钮位置按钮
    showAddBut () {
      // 获取当前滚动条向下滚动的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 当页面滚动到高度300px处时，显示加入我们
      if (scrollTop > 300) {
        this.showJoin = true
      } else {
        this.showJoin = false
      }
    },
    getList (page = this.currentPage) {
      this.currentPage = page
      this.$http
        .post(
          `/front/custCompanyEmpower/frontPageList`,
          {
            page: page,
            limit: 20
          }
        )
        .then(data => {
          // console.log(data);
          if (data.data.code === 0) {
            this.total = Number(data.data.data.count) || 0
            this.dataList = data.data.data.data
          } else {
            this.total = 0
            this.dataList = []
          }
        })
        .catch(() => {
          this.total = 0
          this.dataList = []
        })
        .finally(() => {
          this.loading = false
        })
    }
  }

}
</script>

<style lang="scss" scoped>
.cooperation{
  width: 1190px;
  margin: 10px auto;
  .title{
    font-size: 32px;
    font-weight: 500;
    // color: #FFFFFF;
    line-height: 45px;
  }
  .title-en{
    font-size: 14px;
    font-weight: 500;
    // color: #FFFFFF;
    line-height: 20px;
  }
  .top{
    .top-left{
      position: relative;
      width: 263px;
      height: 228px;
      border-top: 228px solid #1F6FBD;
      // border-left: 100px solid transparent;
      border-right: 50px solid transparent;
      .left-content{
        position: absolute;
        top: -228px;
        padding: 10px;
        height: 228px;
        .title{
          color: #FFFFFF;
        }
        .title-en{
          color: #FFFFFF;
        }
      }
    }
    .top-right{
      position: relative;
      width: 594px;
      height: 200px;
      margin: 14px 0;
      border-bottom: 200px solid #fff;
      border-left: 50px solid transparent;
      // border-right: 100px solid transparent;
      margin-left: -40px;
      -webkit-box-shadow: 2px 3px 3px #666666;
      .right-content{
        position: absolute;
        // top: -228px;
        padding: 10px;
        // height: 228px;
        .title{
          color: #333333;
          line-height: 24px;
          font-size: 16px;
        }
        .right-content-en{
          margin-top: 10px;
          color: #FFFFFF;
          line-height: 20px;
        }
      }
    }
  }
  .product{
    width: 247px;
    .product-up{
      width: 247px;
      height: 190px;
      display: flex;
      align-items: center;
      justify-content: center;
      // text-align: center;
      color: #fff;
      background-size: 100% 100%;
    }
    .product-down{
      width: 247px;
      height: 236px;
      background-size: 100% 100%;
      text-align: center;
      padding-top: 20px;
    }
    .pu1{
      background-image: url(~@/assets/img/ecologicalCooperation/product1.png);
    }
    .pu2{
      background-image: url(~@/assets/img/ecologicalCooperation/product2.png);
    }
    .pu3{
      background-image: url(~@/assets/img/ecologicalCooperation/product3.png);
    }
    .pu4{
      background-image: url(~@/assets/img/ecologicalCooperation/product4.png);
    }
    .pd1{
      background-image: url(~@/assets/img/ecologicalCooperation/productbg1.png);
    }
    .pd2{
      background-image: url(~@/assets/img/ecologicalCooperation/productbg2.png);
    }
    .pd3{
      background-image: url(~@/assets/img/ecologicalCooperation/productbg3.png);
    }
    .pd4{
      background-image: url(~@/assets/img/ecologicalCooperation/productbg4.png);
    }
  }
  .company{
    margin: 10px auto;
    width: 177px;
    height: 88px;
    background: linear-gradient(322deg, #5196D9 0%, #1F6FBD 100%);
    border-radius: 15px;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 25px;
    padding: 0 20px;
  }
  .fixd-but{
    position: fixed;
    right: calc((100vw - 1190px) / 2);
  }
}
</style>
